import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import QuizIcon from "@mui/icons-material/Quiz";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useDispatch, useSelector } from "react-redux";
import { createAxios } from "../../createAxios";
import { createAnswer, uploadAudio, uploadImage } from "../../redux/apiRequest";
import AdminFormFrame from "../AdminFormFrame/AdminFormFrame";
import { getUserId } from "../../utils/authSession";

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    bgcolor: "var(--toeic-surface)",
    "& fieldset": { borderColor: "var(--toeic-line)", borderStyle: "dotted" },
    "&:hover fieldset": { borderColor: "var(--toeic-sky)" },
    "&.Mui-focused fieldset": { borderColor: "var(--toeic-sky)", borderWidth: 1.5 },
  },
  "& .MuiInputLabel-root": { fontWeight: 500 },
  "& .MuiInputLabel-root.Mui-focused": { color: "var(--toeic-sky-deep)" },
};

function CreateAnswer() {
  const [name, setName] = useState("");
  const [answer, setAnswer] = useState("");
  const [file, setFile] = useState(null);
  const [audio, setAudio] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [isAudioLoading, setIsAudioLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user.signin.currentUser);
  const accessToken = currentUser?.metadata.tokens.accessToken;
  const userID = getUserId(currentUser);
  const axiosJWT = createAxios(currentUser);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleAudioChange = (event) => {
    setAudio(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const answerData = {
      name: name,
      content: answer,
      image: "",
      audio: "",
    };

    if (file) {
      setIsImageLoading(true);
      const imageData = await uploadImage(file, "", dispatch);

      if (imageData.img_url) {
        answerData.image = imageData.img_url;
      }
      setIsImageLoading(false);
    }

    if (audio) {
      setIsAudioLoading(true);
      const audioData = await uploadAudio(audio, dispatch);

      if (audioData.audio_url) {
        answerData.audio = audioData.audio_url;
      }
      setIsAudioLoading(false);
    }

    await createAnswer(
      accessToken,
      userID,
      answerData,
      dispatch,
      navigate,
      axiosJWT
    );
  };


  return (
    <AdminFormFrame
      title="Create Test"
      eyebrow="Test management"
      description="Add a new TOEIC answer sheet with answer key, image, and audio."
      icon={QuizIcon}
      color="#2196f3"
      bg="#edf7ff"
      backHref="/management/test"
      tips={["Use a clear test name.", "Answer key should contain 200 A-D answers.", "Upload audio before submitting if the test has listening parts."]}
    >
      <form onSubmit={handleSubmit}>
        <Box mb={2}>
          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={fieldSx}
          />
        </Box>
        <Box mb={2}>
          <TextField
            fullWidth
            label="Answer"
            variant="outlined"
            multiline={true}
            rows={6}
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            sx={fieldSx}
          />
        </Box>
        <Box mb={2}>
          <Button variant="outlined" component="label" fullWidth startIcon={<UploadFileIcon />} sx={{ borderRadius: "14px", borderStyle: "dotted", fontWeight: 700 }}>
            {isImageLoading ? (
              <>
                <CircularProgress style={{ color: "#FFFFFF" }} size={24} />
                &nbsp;Updating Image...
              </>
            ) : (
              "Upload Image"
            )}
            <input type="file" hidden onChange={handleFileChange} />
          </Button>
        </Box>
        <Box mb={2}>
          <Button variant="outlined" component="label" fullWidth startIcon={<UploadFileIcon />} sx={{ borderRadius: "14px", borderStyle: "dotted", fontWeight: 700 }}>
            {isAudioLoading ? (
              <>
                <CircularProgress style={{ color: "#FFFFFF" }} size={24} />
                &nbsp;Updating Audio...
              </>
            ) : (
              "Upload Audio"
            )}
            <input type="file" hidden onChange={handleAudioChange} />
          </Button>
        </Box>
        <Box mb={2}>
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ borderRadius: "14px", bgcolor: "#35c759", color: "#ffffff", fontWeight: 700, "&:hover": { bgcolor: "#2fb44f" } }}
          >
            Submit
          </Button>
        </Box>
      </form>
    </AdminFormFrame>
  );
}

export default CreateAnswer;



